import { render, staticRenderFns } from "./expressway.vue?vue&type=template&id=4a2d5d46&scoped=true"
import script from "./expressway.vue?vue&type=script&lang=js"
export * from "./expressway.vue?vue&type=script&lang=js"
import style0 from "./expressway.vue?vue&type=style&index=0&id=4a2d5d46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2d5d46",
  null
  
)

export default component.exports